import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { selectBuckets, selectCurrentDate } from "../buckets/slice/buckets";
import { filteredBucketList } from "../buckets/slice/lucket-model/filterBuckets";
import { BUCKETLIST_CONTAINER_BACKGROUND_COLOR, LUCKET_DETAILS_BACKGROUND_COLOR, STATUS_OPTION_HEX_PALLETE, STEP_OPTION, TIMEFRAME } from "../buckets/constants";
import "./SpreadsheetTable.css";
import { Tooltip } from "@mui/material";

const SpreadsheetTable = ({ view, dayBuckets, weekBuckets, allBuckets, isExpanded }) => {
  const tableRef = useRef(null);

  const buckets = isExpanded.length > 0
    ? allBuckets
    : view === TIMEFRAME.Day
      ? dayBuckets
      : view === TIMEFRAME.Week
        ? weekBuckets
        : allBuckets;

  // Group buckets by category
  const groupedBuckets = buckets.reduce((acc, bucket) => {
    if (!acc[bucket.category]) {
      acc[bucket.category] = [];
    }
    acc[bucket.category].push(bucket);
    return acc;
  }, {});
  const expandedChildBuckets = buckets.filter(b => b.parentRowID === isExpanded);
  const expandedBucket = buckets.find(b => b.rowID === isExpanded);

  let maxWidthTable = `${buckets.length * 100}px`;

  return buckets.length > 0 && (
    <div className="spreadsheet-table-container" style={{ maxWidth: maxWidthTable, alignSelf: "center" }}>
      <table className="spreadsheet-table" ref={tableRef} style={{ borderColor: LUCKET_DETAILS_BACKGROUND_COLOR, borderStyle: "Solid" }}>
        <thead>
          <tr style={{ position: "sticky" }}>
            {!(isExpanded.length > 0) ? Object.keys(groupedBuckets).map((category, index) => (
              <Tooltip title={`Category`} key={index}>
                <th style={{ backgroundColor: BUCKETLIST_CONTAINER_BACKGROUND_COLOR, borderColor: LUCKET_DETAILS_BACKGROUND_COLOR }} colSpan={groupedBuckets[category].filter(b => !b.parentRowID).length}>
                  {category}
                </th>
              </Tooltip>
            )) : <Tooltip title={`Category`}>
              <th style={{ backgroundColor: BUCKETLIST_CONTAINER_BACKGROUND_COLOR, borderColor: LUCKET_DETAILS_BACKGROUND_COLOR }} key={`expandedBucketCategoryST`} colSpan={expandedChildBuckets.length}>
                {expandedBucket.category + expandedBucket.order}
              </th>
            </Tooltip>
            }
          </tr>
        </thead>
        <tbody>
          <tr>
            {(!(isExpanded.length > 0) ? buckets.filter(b => !b.parentRowID) : expandedChildBuckets).map((bucket, index) => {
              const displayText = `${bucket.order}`;
              const textColor = bucket.status === 'white' ? 'black' : 'white';
              return (
                <Tooltip title={`order and status: ${bucket.name}`} key={index}>
                  <td style={{ backgroundColor: STATUS_OPTION_HEX_PALLETE[bucket.status], borderColor: LUCKET_DETAILS_BACKGROUND_COLOR, borderStyle: "solid", color: textColor }}>
                    {displayText}
                  </td>
                </Tooltip>
              );
            })}
          </tr>
          {(view === TIMEFRAME.Day || view === TIMEFRAME.All) &&
            <tr>
              {(!(isExpanded.length > 0) ? buckets.filter(b => !b.parentRowID) : expandedChildBuckets).map((bucket, index) => {
                const textColor = bucket.actionStatus === 'white' ? 'black' : 'white';
                return (
                  <Tooltip title={`Total action points and action status: ${bucket.name}`} key={index}>
                    <td style={{ backgroundColor: STATUS_OPTION_HEX_PALLETE[bucket.actionStatus], borderColor: LUCKET_DETAILS_BACKGROUND_COLOR, borderStyle: "solid", color: textColor }}>
                      {bucket.points}
                    </td>
                  </Tooltip>
                );
              })}
            </tr>
          }
          {(view === TIMEFRAME.Week || view === TIMEFRAME.All) &&
            <tr>
              {buckets.filter(b => !b.parentRowID).map((bucket, index) => {
                const textColor = bucket.weekActionStatus === 'white' ? 'black' : 'white';
                return (
                  <Tooltip title={`Total week action points and week action status: ${bucket.name}`} key={index}>
                    <td style={{ backgroundColor: STATUS_OPTION_HEX_PALLETE[bucket.weekActionStatus], borderColor: LUCKET_DETAILS_BACKGROUND_COLOR, borderStyle: "solid", color: textColor }}>
                      {bucket.weekPoints}
                    </td>
                  </Tooltip>
                );
              })}
            </tr>
          }
        </tbody>
      </table >
    </div >
  );
};

const SpreadsheetTableContainer = ({ timeFrame, isExpanded }) => {
  const [view, setView] = useState("day");
  const buckets = useSelector(selectBuckets);
  const currentDate = useSelector(selectCurrentDate);

  const dayBuckets = filteredBucketList(
    buckets,
    STEP_OPTION.Do,
    TIMEFRAME.Day,
    currentDate
  );
  const weekBuckets = filteredBucketList(
    buckets,
    STEP_OPTION.Do,
    TIMEFRAME.Week,
    currentDate
  );
  const allBuckets = filteredBucketList(
    buckets,
    STEP_OPTION.Plan,
    "N/A",
    currentDate
  );

  return (
    <SpreadsheetTable
      isExpanded={isExpanded}
      view={timeFrame}
      dayBuckets={dayBuckets}
      weekBuckets={weekBuckets}
      allBuckets={allBuckets}
    />
  );
};

export default SpreadsheetTableContainer;
